import { render, staticRenderFns } from "./companyMsg.vue?vue&type=template&id=0f63ffdc&"
import script from "./companyMsg.vue?vue&type=script&lang=js&"
export * from "./companyMsg.vue?vue&type=script&lang=js&"
import style0 from "./companyMsg.vue?vue&type=style&index=0&id=0f63ffdc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports